import { ADOBE_VIEW_REGEX_MAPPING_PT } from './constants';
import { ViewMappingPart } from './types';

export const resolveViewMapping = (storeConfUserData: Record<string, string>): ViewMappingPart[] =>
	Object.keys(storeConfUserData)
		.filter((key) => key.startsWith(ADOBE_VIEW_REGEX_MAPPING_PT))
		.sort(
			(a, b) =>
				parseInt(a.replace(ADOBE_VIEW_REGEX_MAPPING_PT, ''), 10) -
				parseInt(b.replace(ADOBE_VIEW_REGEX_MAPPING_PT, ''), 10)
		)
		.map((key) => {
			try {
				return JSON.parse(storeConfUserData[key]);
			} catch (e) {
				console.error(`${key} has invalid JSON:`, e);
				return null;
			}
		})
		.filter((mapping): mapping is ViewMappingPart => mapping !== null);

export const resolveViewName = ({
	pathname,
	mappings,
}: {
	pathname: string;
	mappings: ViewMappingPart[];
}): string | undefined =>
	mappings
		.flatMap((mapping) => mapping?.views || [])
		.find((view) => new RegExp(view.pathname).test(pathname))?.name;
